module.exports = __webpack_public_path__ + "img/downLoad.59df62ee.svg";